import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import color from "@constants/color";
import { useFocusEffect } from "@react-navigation/native";
import { getReconDbs } from "@services/api";
import React, { useCallback, useState } from "react";
import {
  FlatList,
  View,
  StyleSheet,
  ActivityIndicator,
  TouchableOpacity,
  Image,
} from "react-native";
import Text from "@components/CustomText";
import NoRecon from "@assets/images/norecon.png";
import ReconListTile from "./components/ReconListTile";

const Recon = ({ navigation, route }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, []),
  );

  const fetchData = async () => {
    try {
      setLoading(true);
      // eslint-disable-next-line no-shadow
      const { data } = await getReconDbs();
      setData(data?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const renderItem = ({ item }) => {
    return <ReconListTile item={item} />;
  };
  return (
    <View style={{ flex: 1 }}>
      <HeaderWithBackAndTitle
        headertitle="Recon"
        headerColor="#fff"
        hideShadow={true}
        navigation={navigation}
        route={route}
        rightComponent={
          <TouchableOpacity
            testID="recon-history"
            onPress={() => navigation.navigate("ReconHistory")}
            style={styles.rightComponent}
          >
            <Text variant="caption_1" style={{ color: color.black }}>
              History
            </Text>
          </TouchableOpacity>
        }
      />
      {loading ? (
        <ActivityIndicator
          size="large"
          color={color.primary}
          style={styles.loading}
        />
      ) : (
        <FlatList
          data={data || []}
          keyExtractor={(item) => item.db_id}
          renderItem={renderItem}
          style={{ marginTop: 8 }}
          ListEmptyComponent={() => (
            <View
              style={{
                flex: 1,
                borderBottomWidth: 1,
                borderBottomColor: color.black,
                marginHorizontal: 20,
                marginTop: 20,
              }}
            >
              <Image source={NoRecon} style={styles.image} />
            </View>
          )}
        />
      )}
    </View>
  );
};

export default Recon;

const styles = StyleSheet.create({
  loading: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  rightComponent: {
    flexDirection: "row",
    alignItems: "center",
    borderColor: color.lighterBlack,
    borderWidth: 1,
    padding: 12,
    paddingTop: 5,
    paddingBottom: 7,
    borderRadius: 30,
  },
  image: {
    alignSelf: "center",
    flex: 1,
    resizeMode: "contain",
    marginTop: "35%",
  },
});
